import React, { useState } from 'react';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../redux/actions/auth.actions';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Header.css';

const Header = ({ isCollapsed }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const toggle = () => setDropdownOpen(!dropdownOpen);
  const { user } = useSelector(
    (state) => state.authReducer
  );
  const dispatch = useDispatch();
  const profileName = user?.user_name || 'User';
  const profileEmail =
    user?.user_email ||
    (user?.user_name?.includes('@') ? user.user_name : 'No email');
  const profileInitial = profileName?.charAt(0)?.toUpperCase() || 'U';
  const welcomeName = profileName?.split('@')[0];

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <motion.header
      initial={{ y: -10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
      className={`app-header ${isCollapsed ? 'collapsed' : ''}`}
    >
      <div className="header-copy">
        <h1 className="header-title">
          Welcome <span className="header-user capitalize">{welcomeName} 👋</span>
        </h1>
        <p className="header-subtitle">Vouchers Management System</p>
      </div>
      <Dropdown isOpen={dropdownOpen} toggle={toggle} className="header-profile">
        <DropdownToggle
          caret
          className="profile-toggle"
        >
          <span className="profile-avatar">{profileInitial}</span>
          <span className="profile-meta">
            <span className="profile-name">{profileName}</span>
            <span className="profile-email">{profileEmail}</span>
          </span>
        </DropdownToggle>
        <DropdownMenu end className="header-menu">
          <DropdownItem onClick={handleLogout}>Logout</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </motion.header>
  );
};

export default Header;
